"use client";

import React from "react";
import { MobileHeader } from "../MobileHeader";
import { AlertsHeader } from "../AlertsHeader";
import { AlertsList } from "../AlertsList";
import { TabBar } from "../TabBar";

function AlertsDashboard() {
  const [activeFilter, setActiveFilter] = React.useState("all");

  const handleTabChange = (tabId: string) => {
    setActiveFilter(tabId);
  };

  return (
    <main className="pb-16 mx-auto w-full max-w-[480px]">
      <div className="overflow-hidden w-full bg-white min-h-[881px]">
        <MobileHeader />

        <div className="pt-8 pb-12 w-full">
          <AlertsHeader 
            initialActiveTab={activeFilter} 
            onTabChange={handleTabChange}
          />

          <div className="px-4 mt-8 w-full">
            <AlertsList activeFilter={activeFilter} />
          </div>
        </div>
      </div>

      <TabBar />
    </main>
  );
}

export default AlertsDashboard;
